<template>
  <div>


    <nav id="sidebar" :class="this.sidemenu_minimized" v-if="(show_menu && isBrandingFlag == 1 && isWhiteFlag == 1)">
      <ul class="list-unstyled">
        <li :class="activeRoute('menteedashboard') ? 'active menu-active' : ''" v-if="loggedInUserRole == 'ROLE_MENTEE'">
          <router-link to="/mentee-dashboard">
            <img v-if="activeRoute('menteedashboard')" src="@/assets/manager/home_icon_dashboard_not_selected_white.png" />
            <img v-else src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <span class="menu-item-name white-txt" :class="activeRoute('menteedashboard') ? '' : 'text-muted'">Home</span>
          </router-link>
        </li>
        <li :class="activeRoute('apprenticedashboard') ? 'active menu-active' : ''" v-if="loggedInUserRole == 'ROLE_APPRENTICE'">
          <router-link to="/apprentice-dashboard">
            <img v-if="activeRoute('apprenticedashboard')" src="@/assets/manager/home_icon_dashboard_not_selected_white.png" />
            <img v-else src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <span class="menu-item-name white-txt" :class="activeRoute('apprenticedashboard') ? '' : 'text-muted'">Home</span>
          </router-link>
        </li>
        <li :class="activeRoute('menteeReports') ? 'active menu-active' : ''">
          <router-link to="/mentee/reports">
            <img v-if="activeRoute('menteeReports')" src="@/assets/manager/reports_not_selected_white.png" />
            <img v-else src="@/assets/manager/reports_not_selected.png" />
            <span class="menu-item-name white-txt" :class="activeRoute('menteeReports') ? '' : 'text-muted'">Reports</span>
          </router-link>
        </li>
        <li :class="activeRoute('myprofile') ? 'active menu-active' : ''">
          <router-link to="/myprofile">
            <img v-if="activeRoute('myprofile')" src="@/assets/manager/my_profile_menu_icon_not_selected_white.png" />
            <img v-else src="@/assets/manager/my_profile_menu_icon_not_selected.png" />
            <span class="menu-item-name white-txt" :class="activeRoute('myprofile') ? '' : 'text-muted'">My Profile</span>
          </router-link>
        </li>
        <li :class="activeRoute('mybadges') ? 'active menu-active' : ''">
          <router-link to="/my-badges">
            <img v-if="activeRoute('mybadges')" src="@/assets/manager/my_badges_menu_icon_not_selected_white.png" />
            <img v-else src="@/assets/manager/my_badges_menu_icon_not_selected.png" />
            <span class="menu-item-name white-txt" :class="activeRoute('mybadges') ? '' : 'text-muted'">My Badges</span>
          </router-link>
        </li>
        <li :class="activeRoute('logout') ? 'active menu-active' : ''">
          <router-link to="/logout">
            <img v-if="activeRoute('logout')" src="@/assets/manager/sign_out_menu_icon.png" />
            <img v-else src="@/assets/manager/sign_out_menu_icon.png" />
            <span class="menu-item-name white-txt" :class="activeRoute('logout') ? '' : 'text-muted'">Sign Out</span>
          </router-link>
        </li>
      </ul>
      <div v-if="(show_menu && isBrandingFlag == 1)" class="img_floater">
        <img class="w-60 mt1 mm-logo-class" src="@/assets/MM-logo.png" alt="MentorMentee" style="">
      </div>
      <div class="patent_floater ">
        <div class="patent_floater_text"><i class="fa fa-copyright"></i> {{ year }} Mentor Mentee</div>
        <div class="patent_floater_text" >Patent Pending</div>
      </div>
    </nav>

    <nav id="sidebar" :class="this.sidemenu_minimized" v-else-if="(show_menu && isBrandingFlag == 1)">
      <ul class="list-unstyled">
        <li :class="activeRoute('menteedashboard') ? 'active menu-active' : ''" v-if="loggedInUserRole == 'ROLE_MENTEE'">
          <router-link to="/mentee-dashboard">
            <img v-if="activeRoute('menteedashboard')" src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <img v-else src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('menteedashboard') ? '' : 'text-muted'">Home</span>
          </router-link>
        </li>
        <li :class="activeRoute('apprenticedashboard') ? 'active menu-active' : ''" v-if="loggedInUserRole == 'ROLE_APPRENTICE'">
          <router-link to="/apprentice-dashboard">
            <img v-if="activeRoute('apprenticedashboard')" src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <img v-else src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('apprenticedashboard') ? '' : 'text-muted'">Home</span>
          </router-link>
        </li>
        <li :class="activeRoute('menteeReports') ? 'active menu-active' : ''">
          <router-link to="/mentee/reports">
            <img v-if="activeRoute('menteeReports')" src="@/assets/manager/reports_not_selected.png" />
            <img v-else src="@/assets/manager/reports_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('menteeReports') ? '' : 'text-muted'">Reports</span>
          </router-link>
        </li>
        <li :class="activeRoute('myprofile') ? 'active menu-active' : ''">
          <router-link to="/myprofile">
            <img v-if="activeRoute('myprofile')" src="@/assets/manager/my_profile_menu_icon_not_selected.png" />
            <img v-else src="@/assets/manager/my_profile_menu_icon_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('myprofile') ? '' : 'text-muted'">My Profile</span>
          </router-link>
        </li>
        <li :class="activeRoute('mybadges') ? 'active menu-active' : ''">
          <router-link to="/my-badges">
            <img v-if="activeRoute('mybadges')" src="@/assets/manager/my_badges_menu_icon_not_selected.png" />
            <img v-else src="@/assets/manager/my_badges_menu_icon_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('mybadges') ? '' : 'text-muted'">My Badges</span>
          </router-link>
        </li>
        <li :class="activeRoute('logout') ? 'active menu-active' : ''">
          <router-link to="/logout">
            <img v-if="activeRoute('logout')" src="@/assets/manager/sign_out_menu_icon.png" />
            <img v-else src="@/assets/manager/sign_out_menu_icon.png" />
            <span class="menu-item-name" :class="activeRoute('logout') ? '' : 'text-muted'">Sign Out</span>
          </router-link>
        </li>
      </ul>
      <div v-if="(show_menu && isBrandingFlag == 1)" class="img_floater">
        <img class="w-60 mt1 mm-logo-class" src="@/assets/MM-logo.png" alt="MentorMentee" style="">
      </div>
      <div class="patent_floater ">
        <div class="patent_floater_text"><i class="fa fa-copyright"></i> {{ year }} Mentor Mentee</div>
        <div class="patent_floater_text" >Patent Pending</div>
      </div>
    </nav>

    <nav id="sidebar" :class="this.sidemenu_minimized" v-else-if="(show_menu  && isBrandingFlag === 0)">
      <ul class="list-unstyled">
        <li :class="activeRoute('menteedashboard') ? 'active' : ''" v-if="loggedInUserRole == 'ROLE_MENTEE'">
          <router-link to="/mentee-dashboard">
            <img v-if="activeRoute('menteedashboard')" src="@/assets/manager/home_icon_dashboard_selected.png" />
            <img v-else src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('menteedashboard') ? '' : 'text-muted'">Home</span>
          </router-link>
        </li>
        <li :class="activeRoute('apprenticedashboard') ? 'active' : ''" v-if="loggedInUserRole == 'ROLE_APPRENTICE'">
          <router-link to="/apprentice-dashboard">
            <img v-if="activeRoute('apprenticedashboard')" src="@/assets/manager/home_icon_dashboard_selected.png" />
            <img v-else src="@/assets/manager/home_icon_dashboard_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('apprenticedashboard') ? '' : 'text-muted'">Home</span>
          </router-link>
        </li>
        <li :class="activeRoute('menteeReports') ? 'active' : ''">
          <router-link to="/mentee/reports">
            <img v-if="activeRoute('menteeReports')" src="@/assets/manager/reports_selected.png" />
            <img v-else src="@/assets/manager/reports_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('menteeReports') ? '' : 'text-muted'">Reports</span>
          </router-link>
        </li>
        <li :class="activeRoute('myprofile') ? 'active' : ''">
          <router-link to="/myprofile">
            <img v-if="activeRoute('myprofile')" src="@/assets/manager/my_profile_menu_icon_selected.png" />
            <img v-else src="@/assets/manager/my_profile_menu_icon_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('myprofile') ? '' : 'text-muted'">My Profile</span>
          </router-link>
        </li>
        <li :class="activeRoute('mybadges') ? 'active' : ''">
          <router-link to="/my-badges">
            <img v-if="activeRoute('mybadges')" src="@/assets/manager/my_badges_menu_icon_selected.png" />
            <img v-else src="@/assets/manager/my_badges_menu_icon_not_selected.png" />
            <span class="menu-item-name" :class="activeRoute('mybadges') ? '' : 'text-muted'">My Badges</span>
          </router-link>
        </li>
        <li :class="activeRoute('logout') ? 'active' : ''">
          <router-link to="/logout">
            <img v-if="activeRoute('logout')" src="@/assets/manager/sign_out_menu_icon.png" />
            <img v-else src="@/assets/manager/sign_out_menu_icon.png" />
            <span class="menu-item-name" :class="activeRoute('logout') ? '' : 'text-muted'">Sign Out</span>
          </router-link>
        </li>
      </ul>
      <div v-if="(show_menu && isBrandingFlag == 1)" class="img_floater">
        <img class="w-60 mt1 mm-logo-class" src="@/assets/MM-logo.png" alt="MentorMentee" style="">
      </div>
      <div class="patent_floater ">
        <div class="patent_floater_text"><i class="fa fa-copyright"></i> {{ year }} Mentor Mentee</div>
        <div class="patent_floater_text" >Patent Pending</div>
      </div>
    </nav>


    <nav id="sidebar" v-if="show_back_button" 
      :class="show_back_button ? 'sidebar_view_mentee' : ''"
    >
      <ul class="list-unstyled">
        <li class="" v-if="loggedInUserRole == 'ROLE_MENTEE'">
          <router-link :to="this.back_link ? { name: this.back_link } : '/mentee-dashboard'" class="text-uppercase text-muted pt-1">
            <img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />
            Back
          </router-link>
        </li>
        <li class="" v-if="loggedInUserRole == 'ROLE_APPRENTICE'">
          <router-link :to="this.back_link ? { name: this.back_link } : '/apprentice-dashboard'" class="text-uppercase text-muted pt-1">
            <img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />
            Back
          </router-link>
        </li>
      </ul>
      <div v-if="(show_menu && isBrandingFlag == 1)" class="img_floater">
        <img class="w-60 mt1 mm-logo-class" src="@/assets/MM-logo.png" alt="MentorMentee" style="">
      </div>
      <div class="patent_floater ">
        <div class="patent_floater_text"><i class="fa fa-copyright"></i> {{ year }} Mentor Mentee</div>
        <div class="patent_floater_text" >Patent Pending</div>
      </div>
    </nav>

  </div>
  
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import store from '../../store/store.js';

export default {
  props: ['show_menu', 'show_back_button', 'back_link', 'active'],
  data() {
    return {
      activeClass: 'nav-active',
      sidemenu_minimized: '',
      loggedInUserRole: '',
      apiUrl: '',
      isBrandingFlag: '',
      isWhiteFlag: 0,
      year: new Date().getFullYear(),
    }
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
    activeRoute() {
      return (routeName) => {
        return this.$route.name === routeName;
      };
    },
  },
  methods: {
  },
  created() {
    this.sidemenu_minimized = this.$store.state.sidebar_menu_minimized;
    document.body.className = 'ma-body-bgcolor-v2';
    this.apiUrl = process.env.API_ENDPOINT;
    if((this.$store.state.user_accountid) && (this.$isBranding === '')) {
      axios('/desktop/get-account-white-labelling-manager-pathwaysettings/' + this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(resp => {
        if(resp.data.isWhiteText == 1) {
          this.isWhiteFlag = 1;
          Vue.prototype.$whiteFlag = 1;
        }
        if(resp.data.logoName) {
            this.$logoName = resp.data.logoName;
            this.isBrandingFlag = 1;
            Vue.prototype.$whiteFlag = 1;
        }
        else {
            this.$logoName = 'MM-logo.png';
            this.isBrandingFlag = 0;
            Vue.prototype.$whiteFlag = 0;
        }
      })
      .catch(() => {
      });
    }
    else {
      this.logo = this.$logoName;
      this.isBrandingFlag = this.$isBranding;
      this.isWhiteFlag = this.$whiteFlag;
    }

    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MENTEE') > -1) {
      this.loggedInUserRole = 'ROLE_MENTEE';
    } else if (roles.indexOf('ROLE_APPRENTICE') > -1) {
      this.loggedInUserRole = 'ROLE_APPRENTICE';
    }
  }
}
</script>

<style scoped>
.back_icon { width: 13px !important; }
.heading-seperator {
  /* border-bottom: 2px solid #dc2227; */
  border-bottom: 2px solid #00ACEE;
  margin: 10px 10px 0px 10px;
}

.heading {
  font-size: 15px;
  padding-left: 20px;
}

#sidebar {
  min-width: 165px;
  max-width: 165px;
  background-color: #FFFFFF;
  min-height: 100vh;
  transition: opacity 2s linear;
  transform: translate(0);
  opacity: 1;
  padding-top: 105px;
  position: fixed;
}

@media (max-width: 1199.98px) {
  #sidebar {
    min-width: 145px;
    max-width: 145px;
  }
}

.sidebar_view_mentee {
  min-width: 150px !important;
}

#sidebar.active {
  min-width: 60px;
  max-width: 60px;
  text-align: center;  
}

#sidebar .active {
  background-color: #B1E6FA;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  margin-right: 30px;
}

#sidebar.active .menu-item-name {
  display: none;
}

#sidebar.active .sidebar-header h3 {
  display: none;
}

#sidebar.active .sidebar-header strong {
  display: block;
}

#sidebar ul li a {
  text-align: left;
  text-decoration: none;
  font-size: 13px;
  /* font-weight: bold; */
}

#sidebar ul li.active a {
  font-weight: bold;
}

#sidebar.active ul li a {
  padding: 0px 10px;
  text-align: center;
  font-size: 0.85em;
  text-decoration: none;
}

#sidebar.active ul li a i {
  margin-right: 0;
  display: block;
  font-size: 16px;
}

#sidebar.active ul ul a {
  padding: 10px !important;
}

#sidebar.active .dropdown-toggle::after {
  top: auto;
  bottom: 10px;
  right: 50%;
  -webkit-transform: translateX(50%);
  -ms-transform: translateX(50%);
  transform: translateX(50%);
}

#sidebar .sidebar-header {
  padding: 0px 10px 10px 10px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

#sidebar ul.components {
  padding: 5px 0;
  border-bottom: 1px solid #47748b;
}

#sidebar ul li a {
  padding: 0px 10px 0px 10px;
  display: block;
  /* color: #212529; */
  margin-left: 5px;
}

#sidebar ul ul li a {
  padding: 2px;
}

#sidebar ul li a i {
  margin-right: 10px;
}

#sidebar ul li.active a i {
  color: #4DB1D8;
  font-weight: bold;
}

#sidebar ul li.active>a,
#sidebar a[aria-expanded="true"] {
  color: #212529;
}

a[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.app-heading {
  margin-left: 10px;
}

.list-signout-menu {
  bottom: 0px;
  position: absolute;
}

.report-dropdown {
  float: right;
  font-size: 20px;
}

#sidebar.active ul ul {
  display: none;
}

#sidebar ul li {
  padding-top: 5px;
  padding-bottom: 5px;
}

#sidebar ul li a.nav-active,
#sidebar ul li a.router-link-exact-active {
  /* border-left: 3px solid red; */
  /* border-left: 3px solid #00ACEE;
  margin-left: 2px; */
  border-left: none;
}

#sidebar ul li a i {
  width: 15px;
}

#sidebar ul li a img {
  width: 15px;
  margin-right: 10px;
}

#sidebar.active ul li a i {
  width: 35px;
}
.img_floater {
  position: fixed; width: 100%; left: 0px;  bottom: 70px; text-align: center; 
}
.mm-logo-class {
  width: 125px; height: 47px;
  
}
.patent_floater {
  position: fixed; width: 100%; left: 0px;  bottom: 20px; text-align: center; 
}
.patent_floater_text {
  text-align: center; 
  color: #6c757d;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/mentee_sidebar_menu.vue